RelationsRequesterFactory.$inject = ['mx.sb.Agent.DataQuery.DataDefinitionRequester', 'mx.SolutionBuilderAgent.DataQueryService', 'mx.shell.ObjectMapper'];

export function RelationsRequesterFactory(DataDefinitionRequester, dataQueryService, objectMapper) {
	/**
	 * @ngdoc Class
	 * @name mx.sb.Agent.DataQuery.RelationsRequester
	 *
	 * @description
	 * Class Relations Requester
	 *
	 */

	function RelationsRequester(dataQuery) {
		DataDefinitionRequester.call(this, dataQuery);
		this.options = {};
	}

	RelationsRequester.prototype = angular.extend(Object.create(DataDefinitionRequester.prototype), {
		prepareRequest: function (preprocessors) {
			const request = {
				entityClassName: this.options.relation?.relationsConfig.referenceFrom,
				relationName: this.options.relation?.relationsConfig.attributeFrom,
				fragmentId: this.options.relation?.fragmentId,
				addedRelations: this.options.relation?.addedRelations,
				removedRelations: this.options.relation?.removedRelations,

				dataQueryName: this.options.columnDefinition,
				filter: this.options.filter,
				allowedTypes: this.options.allowedTypes,
				archived: this.options.archived,
				filters: this.options.filters || '',

				columns: this.dataQuery.Columns.filter((column) => column.visible)
					.map((column) => column.Name)
					.join(','),
			};

			this.applyPreprocessors(request, preprocessors);

			return request;
		},

		loadEntityById: async function (itemId) {
			const request = this.prepareRequest();
			delete request.addedRelations;
			delete request.removedRelations;
			delete request.relationName;

			request.entityClassName = this.options.relation.relationsConfig.referenceTo;
			request.objectId = itemId;

			const items = await dataQueryService.getRelationItems(request);
			if (items.length) {
				return objectMapper.mapItem(items[0]);
			} else {
				throw new Error('Entity cannot be loaded for current DataQuery');
			}
		},

		isEntityCorrect: async function (entity) {
			if (!this.options.correctEntityFilter) {
				return true;
			}
			const request = this.prepareRequest();
			delete request.addedRelations;
			delete request.removedRelations;

			request.filter = this.options.correctEntityFilter;
			request.objectId = entity._id;

			try {
				const items = await dataQueryService.getRelationItems(request);
				return items?.length === 1;
			} catch (e) {
				return false;
			}
		},
	});

	return RelationsRequester;
}
